.questionHeader {
  padding-right: 1em;
}

.container {
  display: flex;
  flex-wrap: wrap;
}

.schemaPartTitle {
  font-size: 1.4em;
  text-transform: uppercase;
  width: 100%;
  margin-bottom: 1em;
}

.chartContainer {
  width: 350px;
  margin-bottom: 2em;
  flex: 0 0 50%;
}
